import * as types from './actionTypes';
import { api } from './api';
export function updateUserRegistration(user) {
	return { type: types.REGISTRATION__UPDATE_USER, user };
}

export function updatePolicyRegistration(policy) {
	return { type: types.REGISTRATION__UPDATE_POLICY, policy };
}

export function hidePasswordChangedBox() {
	return { type: types.PROFILE__PASSWORD_CHANGED };
}

export function hideEmailChangedBox() {
	return { type: types.PROFILE__EMAIL_CHANGED };
}

export function updateRequireStaffVerification(requiresStaffVerification) {
	return { type: types.REGISTRATION__REQUIRE_STAFF_VERIFICATION, requiresStaffVerification };
}

export function hasAccount(policyNumbers) {
	return api({
		types: [types.REGISTRATION__HAS_ACCOUNT_REQUEST, types.REGISTRATION__HAS_ACCOUNT_SUCCESS, types.REGISTRATION__HAS_ACCOUNT_FAILURE],
		uri: `/api/account/exists`,
		shouldCallAPI: () => true,
        sendJwtBearer: false,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ policyNumbers }),
		},
		payload: { policyNumbers },
	});
}

export function resendConfirmationEmail(user) {
	return api({
		types: [types.REGISTRATION__RESEND_CONFIRMATION_EMAIL_REQUEST, types.REGISTRATION__RESEND_CONFIRMATION_EMAIL_SUCCESS, types.REGISTRATION__RESEND_CONFIRMATION_EMAIL_FAILURE],
		uri: '/api/account/register/resend',
		shouldCallAPI: () => true,
		sendJwtBearer: false,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(user),
		},
		payload: { user },
	});
}

export function registerUser(user) {
	return api({
		types: [types.REGISTRATION__CREATE_USER_REQUEST, types.REGISTRATION__CREATE_USER_SUCCESS, types.REGISTRATION__CREATE_USER_FAILURE],
		uri: '/api/account/register',
		shouldCallAPI: () => true,
		sendJwtBearer: false,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			credentials: 'same-origin',
			body: JSON.stringify(user),
		},
		payload: user,
	});
}

export function verifyPolicy(policy) {
	return api({
		types: [types.REGISTRATION__VERIFY_POLICY_REQUEST, types.REGISTRATION__VERIFY_POLICY_SUCCESS, types.REGISTRATION__VERIFY_POLICY_FAILURE],
		uri: '/api/account/verifypolicy',
		sendJwtBearer: false,
		shouldCallAPI: () => true,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(policy),
		},
		payload: policy,
	});
}

export function verifyFullPolicy(policy) {
	return api({
		types: [types.REGISTRATION__VERIFY_FULL_POLICY_REQUEST, types.REGISTRATION__VERIFY_FULL_POLICY_SUCCESS, types.REGISTRATION__VERIFY_FULL_POLICY_FAILURE],
		uri: '/api/account/verifyfullpolicy',
		sendJwtBearer: false,
		shouldCallAPI: () => true,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(policy),
		},
		payload: policy,
	});
}

export function verifyPolicyByPaymentNumber(body) {
	return api({
		types: [types.REGISTRATION__VERIFY_POLICY_BY_PAYMENT_NUMBER_REQUEST, types.REGISTRATION__VERIFY_POLICY_BY_PAYMENT_NUMBER_SUCCESS, types.REGISTRATION__VERIFY_POLICY_BY_PAYMENT_NUMBER_FAILURE],
		uri: '/api/account/verifypaymentnumber',
		shouldCallAPI: () => true,
		sendJwtBearer: false,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(body),
		},
		payload: { body },
	});
}

export function verifyAccountNumber(body) {
	return api({
		types: [types.REGISTRATION__VERIFY_ACCOUNT_NUMBER_REQUEST, types.REGISTRATION__VERIFY_ACCOUNT_NUMBER_SUCCESS, types.REGISTRATION__VERIFY_ACCOUNT_NUMBER_FAILURE],
		uri: '/api/account/verifyaccountnumber',
		shouldCallAPI: () => true,
		sendJwtBearer: false,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(body),
		},
		payload: { body },
	});
}

export function verifyOnetimePolicy(body) {
	return api({
		types: [types.REGISTRATION__VERIFY_POLICY_BY_PAYMENT_NUMBER_REQUEST, types.REGISTRATION__VERIFY_POLICY_BY_PAYMENT_NUMBER_SUCCESS, types.REGISTRATION__VERIFY_POLICY_BY_PAYMENT_NUMBER_FAILURE],
		uri: '/api/account/verifyonetime',
		shouldCallAPI: () => true,
		sendJwtBearer: false,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(body),
		},
		payload: { body },
	});
}

export function verifyByStaff(policy) {
	return api({
		types: [types.REGISTRATION__VERIFY_POLICY_BYSTAFF_REQUEST, types.REGISTRATION__VERIFY_POLICY_BYSTAFF_SUCCESS, types.REGISTRATION__VERIFY_POLICY_BYSTAFF_FAILURE],
		uri: '/api/account/verifybystaff',
		sendJwtBearer: false,
		shouldCallAPI: () => true,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(policy),
		},
		payload: policy,
	});
}

export function confirmEmail(body) {
	return api({
		types: [types.REGISTRATION__CONFIRM_EMAIL_REQUEST, types.REGISTRATION__CONFIRM_EMAIL_SUCCESS, types.REGISTRATION__CONFIRM_EMAIL_SUCCESS],
		uri: `/api/account/confirmemail?code=${encodeURIComponent(body.code)}&userId=${body.userId}`,
		sendJwtBearer: false,
		shouldCallAPI: () => true,
		config: {
			method: 'get',
		},
		payload: body,
	});
}

export function changePassword(body) {
	return api({
		types: [types.PROFILE__CHANGE_PASSWORD_REQUEST, types.PROFILE__CHANGE_PASSWORD_SUCCESS, types.PROFILE__CHANGE_PASSWORD_FAILURE],
		uri: '/api/account/changepassword',
		shouldCallAPI: () => true,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(body),
		},
		payload: body,
	});
}

export function changeEmail(body) {
	return api({
		types: [types.PROFILE__CHANGE_EMAIL_REQUEST, types.PROFILE__CHANGE_EMAIL_SUCCESS, types.PROFILE__CHANGE_EMAIL_FAILURE],
		uri: '/api/account/sendemailchange',
		shouldCallAPI: () => true,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(body),
		},
		payload: body,
	});
}

export function confirmChangeEmail(body) {
	return api({
		types: [types.PROFILE__CONFIRM_CHANGE_EMAIL_REQUEST, types.PROFILE__CONFIRM_CHANGE_EMAIL_SUCCESS, types.PROFILE__CONFIRM_CHANGE_EMAIL_FAILURE],
		uri: `/api/account/changeemail`,
		sendJwtBearer: false,
		shouldCallAPI: () => true,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(body)
		},
		payload: body,
	});
}
